// extracted by mini-css-extract-plugin
export default {"component":"BonusFooter__component--lc-zaqH4","details":"BonusFooter__details--lc-YR_6B"};